export default "__VITE_ASSET__BIxSHkym__"